import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getNotificationPreferences, saveNotificationPreferences } from '../lib/notificationApi';
import type { NotificationPreferenceConfig } from '../types/notification';

export const preferenceKeys = {
  root: (userId: string | number | null) => ['notification-preferences', userId] as const,
};

export function useNotificationPreferences(userId: string | number | null, enabled: boolean) {
  return useQuery({
    queryKey: preferenceKeys.root(userId),
    queryFn: getNotificationPreferences,
    enabled: enabled && userId != null,
  });
}

export function useSaveNotificationPreferences(userId: string | number | null) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ version, config }: { version: number; config: NotificationPreferenceConfig }) =>
      saveNotificationPreferences(version, config),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: preferenceKeys.root(userId) });
    },
  });
}
